module.exports = __webpack_public_path__ + "img/clian4.a49020c7.png";